export const SIDEBAR_BAR_WIDTH = 112;
export const SIDEBAR_BAR_TABLET_WIDTH = 72;
export const SIDEBAR_BAR_HEIGHT_MOBILE = '5.5rem';
export const SIDEBAR_PANE_WIDTH = 328;

export const CONTRAST_WARNING =
  'This color is hard to see with the current background color';
